import { Form, Grid, TextField } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { FC } from 'react';

import { messages } from './AddressSection.messages';
import type { AddressSectionProps } from './AddressSection.types';

export const AddressSection: FC<AddressSectionProps> = (props) => {
    const { name, qa } = props;

    return (
        <Form.Part>
            <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                <TextField
                    name={`${name}.attentionTo`}
                    qa={domHelpers.generateDataQa(qa, 'attention')}
                    label={messages.addressAttentionLabel}
                    placeholder={messages.addressAttentionPlaceholder}
                    maxLength={constants.xeroConstants.ADDRESS_ATTENTION_TO_MAX_LENGTH}
                />

                <TextField
                    name={`${name}.city`}
                    qa={domHelpers.generateDataQa(qa, 'city')}
                    label={messages.cityLabel}
                    placeholder={messages.cityPlaceholder}
                    maxLength={constants.xeroConstants.ADDRESS_CITY_MAX_LENGTH}
                />

                <TextField
                    multiline
                    minHeight={114}
                    maxHeight={114}
                    name={`${name}.address`}
                    qa={domHelpers.generateDataQa(qa, 'address')}
                    label={messages.addressLabel}
                    placeholder={messages.addressPlaceholder}
                    maxLength={constants.xeroConstants.ADDRESS_MAX_LENGTH}
                />

                <Grid gap={16}>
                    <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                        <TextField
                            name={`${name}.region`}
                            qa={domHelpers.generateDataQa(qa, 'state')}
                            label={messages.stateLabel}
                            placeholder={messages.statePlaceholder}
                            maxLength={constants.xeroConstants.ADDRESS_REGION_MAX_LENGTH}
                        />

                        <TextField
                            name={`${name}.postalCode`}
                            qa={domHelpers.generateDataQa(qa, 'postal-code')}
                            label={messages.postalCodeLabel}
                            placeholder={messages.postalCodePlaceholder}
                            maxLength={constants.xeroConstants.ADDRESS_POST_CODE_MAX_LENGTH}
                        />
                    </Grid>

                    <TextField
                        name={`${name}.country`}
                        qa={domHelpers.generateDataQa(qa, 'country')}
                        label={messages.countryLabel}
                        placeholder={messages.countryPlaceholder}
                        maxLength={constants.xeroConstants.ADDRESS_COUNTRY_MAX_LENGTH}
                    />
                </Grid>
            </Grid>
        </Form.Part>
    );
};

AddressSection.displayName = 'AddressSection';
